import {BillCategory, BillSearchResponse} from '../../interfaces/bill';
import {DateTime} from 'luxon';
import {getDateTime, dayDiff} from './date';

export const getDueDateColor = (bill: BillSearchResponse): string => {
    if (bill.remainingAmountWithTax === 0) {
        return 'success';
    }

    const dueDate = getDateTime(bill.dueDate);
    if (!dueDate.isValid) {
        return 'dark';
    }

    const dayLate = dayDiff(DateTime.now(), dueDate);
    if (dayLate <= 0) {
        return 'yellow';
    }

    if (dayLate <= 7) {
        return 'warning';
    }

    return 'danger';
};

export const getBillCategory = (category: string): string => {
    switch (category) {
        case BillCategory.BILL:
            return 'facture';
        case BillCategory.CREDIT:
            return 'avoir';
        default:
            return 'facture';
    }
};
